module.exports = __webpack_public_path__ + "static/media/brand-car-wreck-home.0ed590c6.png";